import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import noproduct from "../component/img/product_not_found.jpeg";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BlogSection = ({ slug }) => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseurl}GetAllBlogsPublish`)
      .then((res) => {
        const published = res.data.filter((blog) => blog.is_published);
        setBlogs(published);
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err);
      });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <section className="blog-section">
      <div className="blog-container px-4">
        <div className="text-center mb-1">
          <span className="blog-label">BLOGS</span>
        </div>

        {/* 🖥 Desktop View */}
        {/* 🖥 Desktop View (Row + Col) */}
<div className="d-none d-lg-block">
  <div className="row">
    {blogs.length > 0 ? (
      blogs.slice(0, 3).map((blog) => (
        <div className="col-md-4 mb-3" key={blog.id}>
          <div className="blog-card">
            <div className="image-wrapper">
              <img
                src={
                  blog.thumbnail
                    ? `${imageUrl}blog/${blog.thumbnail}`
                    : noproduct
                }
                alt={blog.title}
              />
              <span className="date-badge">
                {new Date(blog.published_at).toLocaleDateString("en-IN")}
              </span>
            </div>

            <div className="card-content">
              <Link to={`/blog/${blog.slug}`}>
                <h3>{blog.title}</h3>
              </Link>

              <Link className="read-more" to={`/blog/${blog.slug}`}>
                READ MORE <span>↗</span>
              </Link>
            </div>
          </div>
        </div>
      ))
    ) : (
      <p style={{ color: "#ccc", textAlign: "center" }}>
        No blog posts available.
      </p>
    )}
  </div>
</div>


        {/* 📱 Mobile View - Slick Slider */}
        <div className="d-md-none">
          <Slider {...settings}>
            {blogs.slice(0, 3).map((blog) => (
              <div key={blog.id} className="p-2">
                <div className="blog-card">
                  <div className="image-wrapper">
                    <img
                      src={
                        blog.thumbnail
                          ? `${imageUrl}blog/${blog.thumbnail}`
                          : noproduct
                      }
                      alt={blog.title}
                    />
                    <span className="date-badge">
                      {new Date(blog.published_at).toLocaleDateString("en-IN")}
                    </span>
                  </div>
                  <div className="card-content">
                    <Link to={`/blog/${blog.slug}`} ><h3>{blog.title}</h3></Link>
                    
                    <Link className="read-more" to={`/blog/${blog.slug}`}>
                      READ MORE <span>↗</span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
